<template lang="pug">
  div(data-testid="attachment-block")
    .bcard-table-list-container(ref="files")
      .panel.panel-default(v-if="value.length > 0")
        table.table.table-striped.table-bordered.bcard-table
          thead.bcard-card-details-file-item
            tr
              th タイトル
              th ファイル名
              th サイズ
              th 更新者
              th.bcard-card-details-td-btns(v-if="hasEditableData")
          tbody.bcard-card-details-file-item
            tr(v-for="(item, index) in value" :data-testid="item.title")
              td
                p.form-control-static.bcard-ui-userdata(:title="item.title" data-testid="-file-title")
                  template(v-if="item.openflag === app_flag.OFF")
                    i.fa.bcard-fa-person-private(title="非公開" data-testid="-icon-private")
                    | &nbsp; {{item.title}}
                  template(v-else) {{item.title}}
              td
                p.form-control-static.bcard-ui-userdata(:title="item.dispname")
                  a(href="#" @click.prevent="$emit('download', item)" :title="item.dispname" data-testid="-file-name") {{item.dispname}}
              //- TODO formatted_size
              td.bcard-ui-userdata(style="text-align:right")
                | {{item.size}}
              td.bcard-ui-userdata
                a(href="#" @click.prevent="showProfile(item.creuser)" :title="item.creuser_full_name") {{item.creuser_full_name}}
              td.bcard-card-details-td-btns(v-if="hasEditableData")
                a.btn.btn-primary.btn-xs(v-if="item.editable === app_flag.ON" @click.prevent="$emit('openEditModal', item)" title="変更" data-testid="-btn-edit")
                  i.fa.fa-edit.fa-fw
                a.btn.btn-danger.btn-xs(v-if="item.deletable === app_flag.ON" @click.prevent="$emit('openDelModal', item)" title="削除" data-testid="-btn-delete")
                  i.fa.fa-trash-o.fa-fw
      p(v-else) 添付ファイルは登録されていません。

    portal(to="modal")
      //- 登録者プロフィールダイアログ
      modal-profile(v-model="modalProfile")
</template>

<script>
import AppMessages from '@/components/molecules/AppMessages'
import ModalProfile from '@/components/organisms/ModalProfile'

export default {
  name: 'AttachmentsList',
  components: { AppMessages, ModalProfile },
  props: {
    // attachments
    value: { type: Array, required: true },
    editable: { type: Boolean, required: true }
  },
  data: function () {
    return {
      // ユーザー情報モーダル
      modalProfile: {
        isOpen: false,
        userId: null
      }
    }
  },
  computed: {
    login_user () {
      return (this.$store.state.base.u && this.$store.getState('login_user')) || {}
    },
    hasEditableData () {
      return this.isMgmt || this.value.some(item => item.creuser === this.login_user.id)
    }
  },
  methods: {
    // プロフィールダイアログを表示する
    showProfile: function (sid_person) {
      this.modalProfile.userId = sid_person
      this.modalProfile.isOpen = true
    }
  }
}
</script>

<style lang="scss" scoped>
.bcard-card-details-file-item {
  th,
  td {
    vertical-align: middle;
  }
  .bcard-card-details-td-btns {
    width: 80px;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/lists/AttachmentsList.vue